var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.solicitud_id)?_c('Visualizador',{attrs:{"tipo_visualizacion":"voto"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }